import { Outlet, Route, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'

// slices
import { isUserAuthenticated, loginState } from '../login/login.slice'

// constants
import { PRIVATE_ROUTE_CHECK } from '../../constants/roles'

// routes
import { PUBLIC_ROUTES } from '../../routes'

const PrivateRoute = () => {
    const { status, userProfile } = useSelector(loginState)

    const params = useLocation()

    if (status !== 'loading' && isUserAuthenticated(userProfile)) {
        if (PRIVATE_ROUTE_CHECK.includes(params.pathname)) {
            return <Outlet />
        } else {
            return <Outlet />
        }
    } else {
        return <Route path={PUBLIC_ROUTES.login} />
    }
}

export default PrivateRoute
